module.exports = __webpack_public_path__ + "img/FixIT_Online_logo_svart.e447d7e4.svg";